export function formatDateTime(dt) {
  if (!dt) return '-'
  const dtParsed = dt.substring(0,10) + 'T03:00:00Z'
  const d = new Date(dtParsed)
  const date = d.toLocaleDateString('pt-BR')
  return `${date}`
}